import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCityReadiness = lazy(() => import("@/pages/admin/AdminCityReadiness"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/city-readiness")({
  component: () => (
    <AdminLayout requiredPermission="view_audit_logs">
      <AdminCityReadiness />
    </AdminLayout>
  ),
});
